import accountApi from '@/apis/other/accountAPI';
import commonFn from '@/commons/commonFunction';
import dvcUserAPI from '@/apis/dvc/dvcUserAPI.js';
import {useBackupCommon} from '@/views/utility/backup/BackupCommon.js';
import sysRoleAPI from '@/apis/di/sysRoleAPI.js';
import mplPlatformAPI from '@/apis/proxy/mplPlatformAPI.js';

export default {
  async getConfigInfo(context, payload) {
    try {
      // let res = await httpClient.getAsync({
      // 	url: api.getAPIUrl() + '/info'
      // });

      // if (res.Success) {
      // 	context.commit('updateConfig', res.Data);
      // }

      context.commit('updateConfig', {CurrentDate: new Date()});
    } catch (ex) {
      commonFn.errorLogging('Lỗi lấy thông tin config:: ', ex);
    }
  },
  async setOrganizationUnit(context, payload) {
    context.commit('updateOrganizationUnit', payload);
  },

  /**
   * Đăng nhập
   */
  async loginCode(context, payload) {
    context.commit('updateLoading', true);
    var res = await accountApi.loginCode(payload);

    context.commit('updateLoading', false);

    if (res) {
      if (res.Token) {
        context.commit('updateToken', res);
      }

      return res;
    }
  },

  /**
   * Từ misaid sẽ gọi về callback api, trên api sẽ xử lý để chọn dữ liệu làm việc
   * Dựa theo phiên bản dữ liệu đó sẽ điều hướng về cụm api tương ứng và mã hóa thông tin user, database để truyền kèm
   * Client nhận dc token này sẽ gọi lên account api để đăng nhập
   */
  async loginCallback(context, payload) {
    context.commit('updateLoading', true);
    var res = await accountApi.loginCallback(payload);

    context.commit('updateLoading', false);

    if (res) {
      if (res.Token) {
        context.commit('updateToken', res);
      }

      return res;
    }
  },

  /**
   * Cập nhật token
   * NHANH3 07.02.2025
   */
  async refreshToken(context, payload) { 
    context.commit('refreshToken', payload);
  },

  /**
   * Lấy lại thông tin đăng nhập
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async loginInfo(context, payload) {
    context.commit('updateLoading', true);
    var res = await accountApi.loginInfo(payload);

    context.commit('updateLoading', false);

    if (res) {
      if (res.Token) {
        context.commit('updateToken', res);
      }

      return res;
    }
  },

  /**
   * Đăng xuất
   */
  async logout(context, payload) {
    context.commit('updateLoading', true);

    // Xác định có đang chạy trên MISA Platform (MPL) hay không, dùng để gọi logout đúng nơi
    const platformType = context.state.Context?.PlatformType;
    const platformVersion = context.state.Context?.PlatformVersion;
    const isMPL = (platformType == 2 || platformType == 3) && platformVersion == 2;

    // đăng xuất dvc trước
    let dvcToken = localStorage.getItem('DVCToken');
    if (dvcToken && dvcToken.length > 0) {
      var dvcRes = await dvcUserAPI.logoutDVC(dvcToken);
    }
    //Xử lý xóa cache lưu thông tin cập nhật thông tư 23
    //TVDAT 29/05/2023
    const keyCache = 'mimosa_update_tt23_noti';
    commonFn.removeLocalStorage(keyCache);
    const keyCacheNoti = 'mimosa_finalcial_invoice_noti';
    commonFn.removeLocalStorage(keyCacheNoti);
    const keyCacheZoom = 'mimosa_zoom_noti';
    commonFn.removeLocalStorage(keyCacheZoom);
    const keyCacheNotiBannerHelpConvertData = 'mimosa_noti_banner_help_convert_data';
    commonFn.removeLocalStorage(keyCacheNotiBannerHelpConvertData);
    commonFn.removeLocalStorage('mimosa_show_notify_update_tt24');

    // Đăng xuất phiên MPL trước (nếu có) — lấy LoginUrl MPL trả về để redirect sau khi logout xong
    let mplLoginUrl = null;
    if (isMPL) {
      try {
        var mplRes = await mplPlatformAPI.logout();
        mplLoginUrl = mplRes?.LoginUrl;
      } catch (ex) {
        // Best-effort: lỗi logout MPL không được chặn luồng logout chính
        console.log(ex);
      }
    }

    var res = await accountApi.logout(payload);

    context.commit('updateLoading', false);
    context.commit('updateLogout', res);

    if (isMPL) {
      localStorage.removeItem('session_context');
    }

    let url = mplLoginUrl || window._misaId.getUrl('logoutUrl');
    location.href = url;
  },

  /**
   * Lấy token
   */
  async getToken(context, payload) {
    context.commit('updateLoading', true);

    // //request
    // let url = [window._apis.Auth, "/accounts/token"].join('');
    // // console.log('url ' + url);
    // let res = await axios.get(url, {
    //   params: payload,
    //   withCredentials: true
    // });
    
    var res = await accountApi.getToken(payload);

    context.commit('updateLoading', false);

    if (res) {
      context.commit('updateToken', res);
      return res;
    }
  },

  /**
   * lấy token mới theo tenant và db mới
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async getTokenNewTenant(context, payload) {
    context.commit('updateLoading', true);
    var res = await accountApi.getTokenNewTenant(payload);
    context.commit('updateLoading', false);

    if (res) {
      context.commit('updateToken', res);
      return res;
    }
  },
  /**
   * Lấy thông tin phân quyền
   */
  async getPermission(context, payload) {
    context.commit('updateLoading', true);

    //request
    var res = await accountApi.getPermission(payload);

    context.commit('updateLoading', false);

    if (res) {
      context.commit('updatePermission', res);
    }

    return res;
  },

  /**
   * Đăng xuất
   */
  async logoff(context) {
    await accountApi.logoff();

    //remove token
    context.commit('removeToken');
  },
  /**
   * remove token
   */
  removeToken(context) {
    //remove token
    context.commit('removeToken');
  },
  /*
   * Lấy trạng thái collapse của left menu
   */
  getLeftMenuCollapse(context, payload) {
    context.commit('updateLeftMenuCollapse', payload);
  },
  /**
   * Cập nhật posted date
   * @param {*} context
   * @param {*} payload
   * tbngoc 28/07/2022
   */
  updatePostedDateContext(context, payload) {
    context.commit('updatePostedDate', payload);
  },
  /**
   * Cập nhật tiến trình tạo dữ liệu
   * @param {*} context
   * @param {*} payload
   * NVTUAN1 30.08.2024
   */
  updateCreateDataProcess(context, payload) {
    context.commit('updateCreateDataProcess', payload);
  },
  /**
   * Cập nhật fiscal start date
   * @param {*} context
   * @param {*} payload
   */
  updateFiscalStartDate(context, payload) {
    context.commit('updateFiscalStartDate', payload);
  },
  /**
   * Cập nhật client id
   * @param {*} context
   * @param {*} clientId
   * NCPHUOC 16/08/2022
   */
  updateSocketClientId(context, clientId) {
    context.commit('updateMimosaSessionId', clientId);
  },

  /**
   * update tab id vào state sử dụng phân biệt giữa các tab của người dùng websocket
   * id này sẽ được thay đổi khi người dùng mở tab mới hoặc F5 lại trình duyệt hiện tại
   * @param {*} context context
   * @param {*} id uuid hiện tại
   * HTHIEP 12.07.2023
   */
  updateTabId(context, id) {
    context.commit('updateTabId', id);
  },

  /**
   * Cập nhật trạng thái disabled topnav khi chuyển đổi
   * @param {*} context
   * @param {*} payload
   * TPNAM 22/11/2022
   */
  atcDisabledConvert(context, payload) {
    context.commit('changeDisabledConvert', payload);
  },

  /**
   * Cập nhật trạng thái disabled topnav khi db đang sao lưu phục hôi
   * @param {*} context
   * @param {*} payload
   * nmtuan4 10.2.2023
   */
  atcDisabledBusyDatabase(context, payload) {
    context.commit('changeDisabledBusyDatabase', payload);
  },
  /**
   * Cập nhật tất cả database đang convert trong tk
   * @param {*} context
   * @param {*} payload
   * TPNAM 22/11/2022
   */
  updateDatabaseConverting(context, payload) {
    context.commit('updateDatabaseConverting', payload);
  },

  /**
   * Cập nhật database đang convert trong tk
   * @param {*} context
   * @param {*} payload
   * NVTOAN2 30/12/2022
   */
  insertDatabaseConverting(context, payload) {
    context.commit('insertDatabaseConverting', payload);
  },

  /**
   * progress convert
   * @param {*} state
   * @param {*} payload
   * NVTOAN2 19/04/2023
   */
  updateConvertProgress(context, payload) {
    context.commit('updateConvertProgress', payload);
  },

  /**
   * Cập nhật convert queue mới nhất
   * @param {*} state
   * @param {*} payload
   * nvtoan2 11/05/2023
   */
  updateLastConvertQueue(context, payload) {
    context.commit('updateLastConvertQueue', payload);
  },

  /**
   * Xóa progress convert
   * @param {*} state
   * @param {*} payload
   * NVTOAN2 24/04/2023
   */
  removeConvertProgress(context, payload) {
    context.commit('removeConvertProgress', payload);
  },

  /**
   * Xóa database convert
   * @param {*} context
   * @param {*} payload
   * NVTOAN2 30/12/2022
   */
  removeDatabaseConverting(context, payload) {
    context.commit('removeDatabaseConverting', payload);
  },

  /**
   * Cập nhật thời gian lần cuối convert
   * @param {*} state
   * @param {*} payload
   * nvtoan2 14/02/2022
   */
  insertCacheTimeConvert(context, payload) {
    context.commit('insertCacheTimeConvert', payload);
  },
  /**
   * Cập nhật thời gian lần cuối convert
   * @param {*} state
   * @param {*} payload
   * nvtoan2 14/02/2022
   */
  removeCacheTimeConvert(context, payload) {
    context.commit('removeCacheTimeConvert', payload);
  },
  /**
   * Cập nhật tất cả database đang convert lỗi
   * @param {*} context
   * @param {*} payload
   * TPNAM 22/11/2022
   */
  updateDatabaseConvertError(context, payload) {
    context.commit('updateDatabaseConvertError', payload);
  },
  /**
   *Cập nhật trường show cảnh báo trong context
   * @param {*} context
   * @param {*} payload
   * NTLOC 9/12/2022
   */
  atcShowWarningDate(context, payload) {
    context.commit('changeShowWarningDate', payload);
  },

  /**
   * ập nhật trường show cảnh báo trên top trong context
   */
  atcShowWarningDateTop(context, payload) {
    context.commit('changeShowWarningDateTop', payload);
  },

  /**
   * ập nhật trường show cảnh báo trên top trong context
   */
  atcShowWarningDateTopClient(context, payload) {
    context.commit('changeShowWarningDateTopClient', payload);
  },

  /**
   *  Cập nhật trường show cảnh báo thanh toán gia hạn trong context
   * @param {*} context
   * @param {*} payload
   * nmtuan4 1.6.2023
   */
  changeShowWarningExtendExpired(context, payload) {
    context.commit('changeShowWarningExtendExpired', payload);
  },

  /**
   * Cập nhật database đang phục hồi
   * @param {*} context
   * @param {*} payload
   * nmtuan4 30/12/2022
   */
  insertDatabaseRestoring(context, payload) {
    context.commit('insertDatabaseRestoring', payload);
  },

  /**
   * Loại bỏ database đang phục hồi
   * @param {*} state
   * @param {*} payload
   * nmtuan4 30/12/2022
   */
  removeDatabaseRestoring(context, payload) {
    context.commit('removeDatabaseRestoring', payload);
  },

  /**
   * Cập nhật database đang sao lưu
   * @param {*} context
   * @param {*} payload
   * nmtuan4 30/12/2022
   */
  insertDatabaseBackuping(context, payload) {
    context.commit('insertDatabaseBackuping', payload);
  },

  /**
   * Cập nhật database đang sao lưu
   * @param {*} context
   * @param {*} payload
   * nmtuan4 30/12/2022
   */
  updatePercentDatabaseBackuping(context, payload) {
    context.commit('updatePercentDatabaseBackuping', payload);
  },

  /**
   * Cập nhật database đang sao lưu
   * @param {*} context
   * @param {*} payload
   * nmtuan4 30/12/2022
   */
  updateDatabaseBackuping(context, payload) {
    context.commit('updateDatabaseBackuping', payload);
  },

  /**
   * Cập nhật database đang phục hồi
   * @param {*} context
   * @param {*} payload
   * nmtuan4 30/12/2022
   */
  updatePercentDatabaseRestoring(context, payload) {
    context.commit('updatePercentDatabaseRestoring', payload);
  },

  /**
   * Cập nhật database đang sao lưu
   * @param {*} context
   * @param {*} payload
   * nmtuan4 30/12/2022
   */
  updateDatabaseRestoring(context, payload) {
    context.commit('updateDatabaseRestoring', payload);
  },

  /**
   * Loại bỏ database đang sao lưu
   * @param {*} state
   * @param {*} payload
   * nmtuan4 30/12/2022
   */
  removeDatabaseBackuping(context, payload) {
    context.commit('removeDatabaseBackuping', payload);
    const state = context.state;
    if (state.Context.DatabaseId == payload.database_id) {
      const {afterBackupSuccess} = useBackupCommon();
      afterBackupSuccess(context, state, payload);
    }
  },

  /**
   * Hủy database đang sao lưu
   * @param {*} state
   * @param {*} payload
   * nmtuan4 30/12/2022
   */
  cancelDatabaseBackuping(context, payload) {
    context.commit('removeDatabaseBackuping', payload);
  },

  /**
   * Cập nhật database trong đơn vị
   * @param {*} context
   * @param {*} payload
   * nvtoan2 07/12/2022
   */
  updateTenantDatabases(context, payload) {
    context.commit('updateTenantDatabases', payload);
  },

  /**
   * Đánh dấu xem báo cáo từ phần hệ nào
   * dqdat1 15/05/2023
   */
  updateReportGroupId(context, groupId) {
    context.commit('updateReportGroupId', groupId);
  },

  /**
   * Cập nhật trạng thái sao lưu thành công
   * ntloc 29/05/2023
   */
  updateBackUpSuccess(context, payload) {
    context.commit('updateBackUpSC', payload);
  },

  /**
   * Cập nhật trạng thái khi đã cập nhật thông tư
   * ncquyen 06/01/2023
   */
  updateStatusTT23(context, payload) {
    context.commit('updateStatusTT23', payload);
  },

  /**
   * Cập nhật trạng thái khi đã cập nhật thông tư
   * ncquyen 29/06/2023
   */
  updateStatusTT76(context, payload) {
    context.commit('updateStatusTT76', payload);
  },
  /**
   * Cập nhật tiến trình sao chép dữ liệu
   * @param {*} context
   * @param {*} payload
   * dtnga3 (06.06.2023)
   */
  updateCopyDataProgress(context, payload) {
    context.commit('updateCopyDataProgress', payload);
  },

  /**
   * Xóa progress sao chép
   * @param {*} state
   * @param {*} payload
   * dtnga3 (08.06.2023)
   */
  removeCopyDataProgress(context, payload) {
    context.commit('removeCopyDataProgress', payload);
  },

  /**
   * Thêm đánh dấu dữ liệu đang sao chép dữ liệu
   * @param {*} context
   * @param {*} payload
   * dtnga3 (06.06.2023)
   */
  insertDatabaseCopyData(context, payload) {
    context.commit('insertDatabaseCopyData', payload);
  },

  /**
   * Cập nhật ds DL đang sao chép
   * dtnag3
   */
  updateDatabaseCopyData(context, payload) {
    context.commit('updateDatabaseCopyData', payload);
  },

  /**
   * xóa các database đang sao chép
   * @param {*} state
   * @param {*} payload array : mảng database_id đã hoàn thành việc sao chép
   * dtnga3 (08.06.2023)
   */
  removeDatabaseCopyData(context, payload) {
    context.commit('removeDatabaseCopyData', payload);
  },

  /*
   * Cập nhật trạng thái gia hạn thành công
   */
  updateRenewalSuccess(context, payload) {
    context.commit('updateRenewalSuccess', payload);
  },

  /**
   * Hàm cập nhật lại giá trị trong context
   * @param {*} context
   * @param {*} payload
   * ptthuy2 27.07.2023
   */
  updateValue(context, payload) {
    context.commit('updateValue', payload);
  },
  /*
   * Lấy trạng thái phóng to Tính năng mới
   */
  getNewFeatureZoom(context, payload) {
    context.commit('updateNewFeatureZoom', payload);
  },

  updateHelpSettlemenZoom(context, payload) {
    context.commit('updateHelpSettlemenZoom', payload);
  },
  /*
   * Lấy phiên bản Tính năng mới
   */
  getVersionNewFeature(context, payload) {
    context.commit('updateVersionNewFeature', payload);
  },
  /**
   * update số lượng người dùng
   */
  updateIsCheckOverUser(context, payload) {
    context.commit('updateIsCheckOverUser', payload);
  },

  /**
   * Thêm dữ liệu kết quả Sắp xếp số chứng từ
   * @param {*} context
   * @param {*} payload
   * dtnga3 (28.11.2023)
   */
  updateSortRefNoResult(context, payload) {
    context.commit('updateSortRefNoResult', payload);
  },
  /**
   * Xóa dữ liệu kết quả Sắp xếp số chứng từ
   * @param {*} context
   * @param {*} payload
   * dtnga3 (28.11.2023)
   */
  removeSortRefNoResult(context, payload) {
    context.commit('removeSortRefNoResult', payload);
  },

  /**
   * Cập nhật quyền mới realtime
   * @param {*} context
   * @param {*} payload
   * ldduy (8.1.2024)
   */
  async updatePermission(context, payload) {
    var newPermission = await sysRoleAPI.getRole(payload);
    context.commit('updatePermission', newPermission);
  },

  /**
   * Cập nhật trạng thái có thông báo sự cố bảo trì trên thanh header không?
   * NVTUAN1 23.05.2024
   */
  updateMISANotifyHeader(context, payload) {
    context.commit('updateMISANotifyHeader', payload);
  },
  /**
   * Cập nhật tab id khi mở page
   * @param {*} context
   * @param {*} payload
   * NCPHUOC 27/05/2024
   */
  syncTabId(context, payload) {
    context.commit('syncTabId', payload);
  },
  /**
   * Cập nhật trạng thái thỏa thuận mua hàng
   * @param {*} context
   * @param {*} payload
   * nthien4
   */
  updateMisaAgreementPurchase(context, payload) {
    context.commit('updateMisaAgreementPurchase', payload);
  },
  /** 
   * Lấy trạng thái trạng thái có đè lên chatbot không
   * @param {*} context
   * @param {*} payload
   */
  atcIsPressChatbot(context, payload) {
    context.commit('updateIsPressChatbot', payload);
  },
};
